import styled from 'styled-components';

import { CancelButton } from 'modules/dashboard/styles/dashboard';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const ModalContainer = styled.div`
  .es-modal {
    border-radius: 12px;
    background-color: ${COLOR_CONFIG.white};
  }

  .es-modal-header {
    font-size: 1.25rem;
    font-weight: 500;
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
    line-height: calc(28 / 20);
  }

  .es-modal-body {
    p {
      font-size: 1rem;
      color: ${COLOR.surfaceNeutralBold['neutral-11']};
      line-height: calc(22 / 16);
    }
  }
`;

export const SubmitConfirmButton = styled(CancelButton)`
  background-color: ${COLOR_CONFIG.red};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: ${COLOR_CONFIG.white};
  }
`;
